import { Api } from '@axiom/ui';
import type { LimitedCandidate } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class LimitedCandidateApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  readLimitedCandidate(id: string) {
    return super.read<{ data: LimitedCandidate }>({
      endpoint: `/limitedCandidates/${id}`,
      method: 'GET',
    });
  }

  async refreshLimitedCandidate(id: string) {
    return super.invalidate(`/limitedCandidates/${id}`);
  }
}

export const LimitedCandidatesApi = new LimitedCandidateApiClass();
